const Oferta = () => {
  return (
    <section className="agreement">
      <div className="container">
        <div className="common-title">
          <h2 className="common-title__h2">
            Пользовательское <span>соглашение</span>
          </h2>
          <p className="common-title__subtitle">на правах договора оферты</p>
          <p
            className="common-title__subtitle"
            style={{
              fontSize: "12px",
              fontStyle: "italic",
              marginTop: "0.5rem",
            }}
          >
            (или много важного текста, который мы обязаны поместить на сайт)
          </p>
        </div>
        <div className="privacy-policy-header">
          <span>г. Москва «18» марта 2024 г.</span>
          <span>Обновлено «18» марта 2024 г.</span>
        </div>
        <div className="privacy-policy-body">
          <p className="privacy-policy-p">
            Текст настоящего Пользовательского соглашения (далее - Соглашение), постоянно размещенный в сети Интернет по адресу
            https://rpmserver.com/roleplay/agreement определяет правила и порядок использования Игрового сервиса, права и обязанности Пользователей.
            <br />
            <br />
            Правообладателем Игрового сервиса является Индивидуальный предприниматель Плужников Алексей Юрьевич (ИНН 772792256884 ОГРНИП
            324774600080992). Принимая условия настоящего Соглашения, Пользователь подтверждает, что является дееспособным в соответствии с
            законодательством места проживания Пользователя, в соответствии с которым Пользователю не запрещается получать игровые услуги в Интернете,
            и в законодательстве страны Пользователя нет других ограничений, в том числе возрастных ограничений для пользования такими услугами. Для
            лиц младше возраста совершеннолетия (правоспособность), Соглашение считается заключенным с их законными представителями (родителями,
            опекунами и т.д.). Правообладатель не следит за дееспособностью Пользователя в рамках настоящего Соглашения и не проверяет достоверность
            предоставленных Пользователем данных.{" "}
            <span style={{ textDecoration: "underline" }}>
              Презюмируется, что Пользователь предоставляет достоверные данные при заключении настоящего Соглашения
            </span>
            .
            <br />
            <br />
            Используя Сайт Пользователь автоматически соглашается со всеми положениями настоящего Соглашения. В случае несогласия Пользователя с
            настоящим Соглашением или Правилами,{" "}
            <span style={{ textDecoration: "underline" }}>Пользователь не вправе использовать Сайт и обязан покинуть его незамедлительно.</span>
          </p>
          <h5 className="privacy-policy-title">1. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</h5>
          <p className="privacy-policy-p">
            1.1. Пользователь - физическое лицо, посещающее Сайт в целях игровой деятельности. Пользователь является стороной Соглашения. <br />
            1.2. Игровой сервис является сайтом для внутриигровых покупок в рамках игрового проекта «RPM ROLEPLAY». <br />
            1.3. Сайт - автоматизированная информационная система, доступная в сети Интернет по адресу (включая поддомены) https://rpmserver.com,
            предоставляющий Пользователю доступ к сервису.
            <br />
            1.4. Сервис – совокупность функциональных возможностей программно-аппаратных средств Правообладателя, включая сайт https://rpmserver.com и
            его поддомены, к которым Пользователю предоставляется доступ на праве использования.
            <br />
            1.5. Материалы - Сайт, программное обеспечение и любая часть Сервиса, компоненты, контент, включая, но не ограничиваясь, любые Аккаунты
            Пользователей, названия, компьютерные коды, файлы, игровое программное обеспечение, клиентское и серверное программное обеспечение,
            аудиодорожки, обновления, картинки, темы, объекты, персонажи, имена, слоганы, местоположение, концепция, иллюстрации, рисунки, графика,
            изображения, видео, анимация, звуки, музыка, композиции, звукозаписи, аудиовизуальные эффекты, информация, данные, документация, апплеты,
            протоколы чатов, информация о персонажах, игровой процесс, сценарии, записи.
          </p>
          <h5 className="privacy-policy-title">2. ОБЩИЕ ПОЛОЖЕНИЯ</h5>
          <p className="privacy-policy-p">
            2.1. В соответствии с условиями настоящего Соглашения, Правообладатель предоставляет Пользователю доступ к сервису приобретения
            внутриигровых покупок.
            <br />
            2.2. Для использования Игрового сервиса и его функционала Пользователь должен пройти регистрацию и создать Игровой аккаунт Пользователя.
            <br />
            2.3. Обязательным условием получения доступа к Игровому сервису является наличие доступа Пользователя к сети Интернет. Пользователь
            самостоятельно и за свой счет оплачивает программное обеспечение своего компьютера и доступ в сеть Интернет. <br />
            2.4. Регистрируя Аккаунт Пользователя Пользователь автоматически соглашается со всеми положениями настоящего Соглашения. В случае
            несогласия Пользователя с настоящим Соглашением, Пользователь не в праве использовать Игровой сервис.
            <br />
            2.5. Пользователь не вправе регистрировать неограниченное количество аккаунтов. Допускается только одного наименования пользователя для
            приобретения внутриигрового товара и (или) услуги.
            <br />
            2.6. Изначальный доступ к Игровому сервису является бесплатным.
            <br />
            2.7. Игровой Аккаунт и всё игровое имущество является неотчуждаемой собственностью Правообладателя, не подлежит продаже за вне игровую
            валюту (имущество), не подлежит продаже или передаче (Аккаунт). Правообладатель вправе распорядиться игровым имуществом по своему
            усмотрению, но лишь при нарушении положений настоящего Соглашения (раздел 3, пп. 3.5.), прекращении действия аккаунта Пользователя.
            <br />
            2.8. Во исполнение п. 2.7. настоящего Соглашения, к нарушением Соглашения так же относятся и нарушение правил Игрового сервиса,
            расположенных по адресу: https://discord.gg/rpmroleplay
            <br />
            2.9. При создании Аккаунта Пользователь обязан предоставлять достоверную, точную, актуальную и полную информацию, которая должна быть
            введена в соответствующие поля, и поддерживать ее актуальность, достоверность, точность и полноту.
            <br />
            2.10. Пользователь несет ответственность за свой Игровой Аккаунт. Если характеристики Аккаунта нарушают условия настоящего Соглашения,
            Правообладатель вправе немедленно отключить его без предварительного уведомления или согласия Пользователя. Правообладатель вправе без
            оснований изменить имя Аккаунта Пользователя без предварительного уведомления последнего.
            <br />
            2.11. Пользователь несет ответственность за сохранение конфиденциальности паролей, связанных с Аккаунтом, который Пользователь использует
            для доступа к Сервису. Пользователь несет исключительную ответственность перед Правообладателем за все действия, которые происходят в
            Аккаунте.
            <br />
            2.12. Правообладатель вправе по своему усмотрению прекратить действие Аккаунта.
          </p>
          <h5 className="privacy-policy-title">3. ПРАВА И ОБЯЗАННОСТИ</h5>
          <p className="privacy-policy-p">
            <span style={{ fontWeight: "bold" }}>3.1. Правообладатель имеет право:</span>
            <br />
            <br />
            3.1.1. изменять дизайн Сайта и (или) его содержимого в любое время с уведомлением Пользователей или без него;
            <br />
            3.1.2. удалять без каких-либо оснований и без уведомления любой контент, Материалы, комментарии, любую информацию, которая по его
            усмотрению нарушает и / или может нарушать действующее законодательство, это Соглашение, Политику конфиденциальности, права других
            Пользователей или третьих лиц, или наносит им вред, или угрожает их безопасности;
            <br />
            3.1.3. удалить Аккаунт Пользователя в случаях, предусмотренных п. 2.12. настоящего Соглашения;
            <br />
            3.1.4. направлять Пользователю сообщения (в том числе посредством электронной почты, смс и т.д.), которые содержат рекламную информацию о
            Сервисе или материалах, тематически связанных с ними;
            <br />
            3.1.5. полностью или частично уменьшить функциональность Сайта, Материалов по техническим, превентивным или иным причинам.
            <br />
            3.1.6. в целях предотвращения неправомерного использования программного обеспечения, а также соблюдения пользователями пользовательского
            соглашения, оператор персональных данных вправе осуществлять фото-видео запись изображения экрана, но в пределах используемого
            программного обеспечения. указанные фото-видео материалы используются внутренней службой оператора, не предоставляются для общественного
            пользования
            <br />
            <br />
            <span style={{ fontWeight: "bold" }}>3.2. Правообладатель обязан:</span>
            <br />
            <br />
            3.2.1. соблюдать настоящее Соглашение.
            <br />
            <br />
            <span style={{ fontWeight: "bold" }}>3.3. Пользователь имеет право:</span>
            <br />
            <br />
            3.3.1. настроить Аккаунт, изменить имя пользователя и пароль для доступа к нему;
            <br />
            3.3.3. осуществлять иные, не запрещенные законом или настоящим Соглашением, действия, касающиеся использования Сайта или Сервиса.
            <br />
            <br />
            <span style={{ fontWeight: "bold" }}>3.4. Пользователь обязан:</span>
            <br />
            <br />
            3.4.1. указать достоверную информацию на момент совершения платежа. Пользователь несет полную ответственность за несоответствие
            указываемых данных;
            <br />
            3.4.2. принять необходимые меры для обеспечения конфиденциальности учетных данных (логина и пароля), используемых для доступа к Аккаунту;
            <br />
            3.4.3. соблюдать настоящее Соглашение, Политику обработки персональных данных.
            <br />
            3.4.4. соблюдать правила Игрового сервиса, расположенные по адресу: https://discord.gg/rpmroleplay
            <br />
            <br />
            <span style={{ fontWeight: "bold" }}>3.5. Пользователь не вправе:</span>
            <br />
            <br />
            3.5.1. использовать Сайт в коммерческих целях без предварительного разрешения Правообладателя;
            <br />
            3.5.2. использовать какое-либо программное обеспечение, ошибки, дефекты в целях получения несанкционированного доступа к Сервису или
            получения неконкурентных преимуществ, в том числе над другими пользователями;
            <br />
            3.5.3. продавать, перепродавать, передавать Материалы, принадлежащие Правообладателю, с коммерческой целью (в том числе игровую валюту,
            игровые ценности, Аккаунт Пользователя и т.п.);
            <br />
            3.5.4. распространять, публично исполнять или публично показывать любые Материалы, принадлежащие Правообладателю.
            <br />
            3.5.6. использовать программное обеспечение для сбора или удаления информации;
            <br />
            3.5.7. загружать (кроме кеша отображения страницы) любую часть Материалов, принадлежащих Правообладателю, или любую содержащуюся в них
            информацию, за исключением случаев, явно предусмотренных предполагаемой функцией Сайта;
            <br />
            3.5.8. копировать, переводить, публиковать, декомпилировать, выполнять технический анализ, дизассемблировать или конвертировать Сайт
            (исходный код Сайта) или осуществлять попытку получить доступ к исходному коду Сайта для создания производных работ на основе исходного
            кода Сайта или иным образом;
            <br />
            3.5.9. загружать, хранить, публиковать, распространять, предоставлять доступ или иным образом использовать любую информацию, инструменты и
            (или) материалы.
          </p>
          <h5 className="privacy-policy-title">4. ПОРЯДОК ОПЛАТЫ</h5>
          <p className="privacy-policy-p">
            4.1. Настоящим Соглашением определено, что к оплате принимаются платежные карты: VISA, MasterCard, Maestro, МИР, Юmoney. Для оплаты товара
            банковской картой при оформлении заказа в интернет-магазине выберите способ оплаты: банковской картой.
            <br />
            4.2. При оплате заказа банковской картой, обработка платежа происходит на авторизационной странице банка, где Вам необходимо ввести данные
            Вашей банковской карты: Тип карты, Номер карты, Срок действия карты, CVC2/CVV2 код.
            <br />
            4.3. Данные, указанные в п. 4.2. настоящего Соглашения, не распространяются Правообладателем, являются конфиденциальной информацией.
            <br />
            4.4. В случае, если банковская карта подключена к услуге 3D-Secure, Пользователь будет автоматически переадресованы на страницу банка,
            выпустившего карту, для прохождения процедуры аутентификации. Информацию о правилах и методах дополнительной идентификации уточняется в
            Банке, выдавшем банковскую карту.
          </p>
          <h5 className="privacy-policy-title">5. ПОЛОЖЕНИЯ ОБ ОТВЕТСТВЕННОСТИ</h5>
          <p className="privacy-policy-p">
            5.1. Правообладатель не несет ответственность за возможные сбои и перерывы в работе Сайта и (или) Сервиса и потерю информации в
            результате. В вышеуказанных случаях (сбоях, недостоверных сведениях Пользователя), Правообладатель не несет ответственности, не обязан
            возмещать убытки.
            <br />
            5.2. Правообладатель не несет ответственность за какой-либо ущерб персональному компьютеру, мобильным устройствам, любому другому
            оборудованию или программному обеспечению Пользователей.
          </p>
          <h5 className="privacy-policy-title">6. ПОРЯДОК ВОЗВРАТА ДЕНЕЖНЫХ СРЕДСТВ</h5>
          <p className="privacy-policy-p">
            6.1. Товары и услуги, указанные на сайте Правообладателя, не подлежат возврату. К исключительным случаям, при которых Правообладатель
            вправе вернуть денежные средства, указанным в настоящем Соглашении, относятся:
            <br />
            1) Сбой платежной системы
            <br />
            2) Повторное списание денежных средств Пользователя в случае неполадок при совершении платежа
            <br />
            <br />
            При всем этом, возврат возможен только в случае, когда оплаченный товар не был использован. При этом, Пользователь обязан указать в
            запросе причину для возврата денег. Немотивированное заявление о возврате денежных средств отклоняется правообладателем в одностороннем
            порядке.
            <br />
            6.2. В случае блокировки Аккаунта по причине нарушения Пользователем Соглашения, возврат денежных средств невозможен.
            <br />
            6.3. Период рассмотрения заявки – 10 дней с даты отправки запроса. Заявление на возврат денежных средств направляется на эл. почту:
            admin@rpmserver.ru
            <br />
            6.4. При оформлении возврата может быть удержан сервисный сбор или комиссия банка\платежной системы, которые удерживаются из суммы,
            подлежащей возврату.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Oferta;
